import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/dashboard?page=1&maxData=1000&searchWord=' // (0) 검색시

let swrData: any = getPersistData(KEY)

export function useSearch(word) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + word,
		async () => {
			const response = await API.get(KEY + word, token + '', {})
			swrData = response.result?.result

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		SearchResult: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}
